import ClientCache from "@/utils/login/ClientCache.ts";
import Translator from "@/utils/common/Translator.ts";
import {date} from "quasar";
import dayjs, {ISO_DATE_FORMATS} from "@/utils/dayjs.ts";
import formatDate = date.formatDate;

export default class DateFieldUtils {
  static dateToString(value: Date | string | null | undefined): string {
    if (!value)
      return '';
    const input: Date = new Date(value);
    if (!ClientCache.getDoNotUseTodayAndYesterdayForDates()) {
      const today: Date = new Date();
      if (input.getFullYear() === today.getFullYear() && input.getMonth() === today.getMonth()) {
        if (input.getDate() === today.getDate())
          return Translator.translateId('today')!;
        else if (input.getDate() === (today.getDate() - 1))
          return Translator.translateId('yesterday')!;
      }
    }
    return formatDate(input, `DD-MM-YYYY`);
  }

  static timeToString(value: Date | string | null | undefined, is24HourFormat?: boolean): string {
    if (!value)
      return '';
    const input: Date = new Date(value);
    if (is24HourFormat)
      return formatDate(input, `HH:mm:ss`);
    return formatDate(input, `hh:mm:ss`) + ' ' + Translator.translateId(input.getHours() < 12 ? 'am' : 'pm');
  }

  static dateAndTimeToString(value: Date | string | null | undefined) {
    if (!value)
      return '';
    return this.dateToString(value) + Translator.translateId('comma') + this.timeToString(value);
  }

  static toDate(value: any): Date {
    return value instanceof Date ? value : new Date(value as any);
  }

  static formatDisplay(timeStamp: string | Date, format: string): string {
    if (!timeStamp)
      timeStamp = new Date();
    const dayjsValue = timeStamp instanceof Date ? dayjs(timeStamp) : dayjs(timeStamp, ISO_DATE_FORMATS);
    return date.formatDate(dayjsValue.format("YYYY-MM-DD"), Translator.isArabic() ? format : format);
  }
}
